<div class="datiq-cell-title">
    <div class="datiq-cell-title__label">
        {{ settings?.label }}
    </div>
</div>
